import { render, staticRenderFns } from "./import-fuelly.vue?vue&type=template&id=4b62b3fc&"
import script from "./import-fuelly.vue?vue&type=script&lang=js&"
export * from "./import-fuelly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports